<button
  type="button"
  class="collapse-header text-primary"
  [ngClass]="{
    'collapse-header--link btn-link btn': variant === 'link',
    'collapse-header--button': variant === 'button'
  }"
  [class.expanded]="isOpen"
  (click)="onOpenChange()"
  [attr.aria-expanded]="isOpen"
  [attr.aria-controls]="'collapseBasic-' + attrId"
  data-track-elem="accordion"
  [attr.data-track-name]="title"
  data-track-trigger="statechange"
  [attr.data-track-state]="isOpen ? 'open' : 'closed'"
  [attr.aria-label]="isOpen ? title + ' expanded' : title + ' collapsed'"
  >
  <i class="allycon-glyph-chevron-down collapse-header__icon text-primary" [class.expanded]="isOpen" aria-hidden="true"></i>
  <span class="collapse-header__title ms-1">
    {{ title }}
  </span>
  <ng-content select="[title-right]"></ng-content>
</button>

<div
  [id]="'collapseBasic-' + attrId"
  [collapse]="!isOpen"
  class="collapse-body-wrap"
  [ngClass]="{
    'collapse-body-wrap--link': variant === 'link',
    'collapse-body-wrap--button': variant === 'button',
    'is-scrollable': scrollable
  }">
  <div class="offer-chains">
    @for (date of previousOffers.dates; track date) {
      @for (offer of previousOffers.offersByDate[date]; track offer; let even = $even) {
        <div
          id="vom_offer_history_text_blob" class="offer-chains--details" [ngClass]="even ? 'row-even' : 'row-odd'">
          <div class="row space-between">
            <p class="bold">{{ offer.role | parseString | uppercase }}</p>
            <p>{{ offerTime(offer.offerDate)}}</p>
          </div>
          <p class="offer-chain--details__item">
            <span class="fw-bold">{{ CONSTANTS.labelOfferAmount }}</span>
          {{ formatCurrency(offer.amount, false) }}</p>
          <p class="offer-chain--details__item">
            <span class="fw-bold">{{ CONSTANTS.textDate }}</span>
            {{ formatDate(offer.offerDate) }}
          </p>
          <div class="offer-chains--comments">
            <p>
              <span class="fw-bold">{{ getCommentLabel(offer.role) }}</span>
              <span class="fst-italic">{{ offer.comment }}</span>
            </p>
          </div>
        </div>
      }
    }
  </div>
</div>
